/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendTabularProductDto } from '../../models/backend-tabular-product-dto';

export interface SalesTabularProductsList$Params {
  /**
   * A search term.
   */
  search?: string;
  variant?: number;
}

export function salesTabularProductsList(
  http: HttpClient,
  rootUrl: string,
  params?: SalesTabularProductsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendTabularProductDto>>> {
  const rb = new RequestBuilder(rootUrl, salesTabularProductsList.PATH, 'get');
  if (params) {
    rb.query('search', params.search, {});
    rb.query('variant', params.variant, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendTabularProductDto>>;
    }),
  );
}

salesTabularProductsList.PATH = '/api/sales/tabular-products/';
